import TeamIcon from "@uui/Briefcase01";

import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import { Link } from "@rui/Link";

const NotEnoughData = ({ type }: { type: "all" | "for_team" }) => (
  <EmptyStateContainer flex={1}>
    <EmptyStateIcon Icon={TeamIcon} padding={2} />
    <EmptyStateTitle>Not enough data</EmptyStateTitle>
    {type === "all" ? (
      <EmptyStateSubtext>
        In order to generate a team report, you must have at least one team with
        3+ associated meetings during the reporting period.
      </EmptyStateSubtext>
    ) : (
      <EmptyStateSubtext>
        In order to generate a team report, you must have 3+ meetings with this
        team during the reporting period.
      </EmptyStateSubtext>
    )}
    <Link to={ROUTES.FOR_YOU}>
      <Button>Back to For You</Button>
    </Link>
  </EmptyStateContainer>
);

export default NotEnoughData;
